import RequestLogsGridContent, { type RequestLogsAgGridProps } from "./RequestLogsGridContent";
import { RequestLogsSelectionProvider } from "./request-logs-selection-context";
import { shouldInitializeStructuredSearchUrlHydration } from "./utils/requestLogsUrlHydration";

import { StructuredSearchProvider } from "@/components/StructuredSearch";

const RequestLogsAgGridWithProvider = ({
  lockedFilters,
  initialDateRange,
  dateRangeMinDate,
  dateRangeMaxDate,
  useExternalStructuredSearchProvider = false,
  syncUrl = true,
  ...rest
}: RequestLogsAgGridProps) => {
  const content = (
    <RequestLogsSelectionProvider>
      <RequestLogsGridContent
        lockedFilters={lockedFilters}
        initialDateRange={initialDateRange}
        dateRangeMinDate={dateRangeMinDate}
        dateRangeMaxDate={dateRangeMaxDate}
        useExternalStructuredSearchProvider={useExternalStructuredSearchProvider}
        {...rest}
      />
    </RequestLogsSelectionProvider>
  );

  if (useExternalStructuredSearchProvider) {
    return content;
  }

  return (
    <StructuredSearchProvider
      initialLockedFilters={lockedFilters}
      initialDateRange={initialDateRange}
      initialUrlHydrationReady={shouldInitializeStructuredSearchUrlHydration(syncUrl)}
    >
      {content}
    </StructuredSearchProvider>
  );
};

export default RequestLogsAgGridWithProvider;
